import { Button, Card, FormLabel, Input } from "@mui/material";
import { useMemo, useState } from "react";
import emailTemplateBuilder from "../../constants/email-template";
import { useMutation } from "react-query";
import { developAxios } from "../../axios.config";
import { Store } from "react-notifications-component";

const CreateEmailTemplate = () => {
	const [name, setName] = useState<string>("");
	const [sessionTopic, setSessionTopic] = useState<string>(
		"Data Structures and Algorithms"
	);
	const [sessionTiming, setSessionTiming] =
		useState<string>("9:00 am to 10:00pm");
	const [sessionUrl, setSessionUrl] = useState<string>("");

	const renderedEmail = useMemo<string>(() => {
		return emailTemplateBuilder(sessionTopic, sessionTiming, sessionUrl);
	}, [sessionTopic, sessionTiming, sessionUrl]);

	const { mutateAsync: createEmailTemplate } = useMutation(
		() => {
			if (!sessionTopic) {
				throw new Error("Session topic is a required field");
			}
			return developAxios(localStorage.getItem("token") || "").post(
				"/superadmin/course/email-template",
				{
					name,
					template: renderedEmail,
				}
			);
		},
		{
			onError: (error: any) => {
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
					return;
				}
				notifyPopup(error.message, "danger");
			},

			onSuccess: () => {
				notifyPopup("Email template created successfully", "success");
			},
		}
	);

	function notifyPopup(backend_message: string, type: "success" | "danger") {
		Store.addNotification({
			title: type === "danger" ? "Error Occured" : "Success",
			message: backend_message,
			type: type,
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	return (
		<div className="container mx-auto p-4">
			<h1 className="text-2xl font-bold mb-4">Email Template Editor</h1>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<Card className="p-4">
					<div className="mb-2">
						<FormLabel htmlFor="template_name">
							Template Name:
						</FormLabel>
						<Input
							id="template_name"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</div>
					<div className="mb-2">
						<FormLabel htmlFor="template">
							Formatted Date:
						</FormLabel>
						<Input
							id="template"
							value={sessionTopic}
							onChange={(e) => setSessionTopic(e.target.value)}
						/>
					</div>
					<div className="mb-2">
						<FormLabel htmlFor="sessionTiming">
							Session Timing:
						</FormLabel>
						<Input
							id="sessionTiming"
							value={sessionTiming}
							onChange={(e) => setSessionTiming(e.target.value)}
						/>
					</div>
					<div className="mb-2">
						<FormLabel htmlFor="template">Session Url:</FormLabel>
						<Input
							id="template"
							value={sessionUrl}
							onChange={(e) => setSessionUrl(e.target.value)}
						/>
					</div>
					<Button
						variant="contained"
						onClick={() => createEmailTemplate()}
					>
						Create
					</Button>
				</Card>
			</div>
			<Card className="mt-4 p-4">
				<h2 className="text-xl font-semibold mb-2">Rendered Email</h2>
				<div
					className="border p-4 rounded bg-white"
					dangerouslySetInnerHTML={{ __html: renderedEmail }}
				/>
			</Card>
		</div>
	);
};

export default CreateEmailTemplate;
